<template>
  <div class="main-content">
    <ActivityDownList :usersForSelect="users"/>
    <ShiftActivation :usersForSelect="users"/>
    <div class="card">
      <div class="card-header">
        <h5>Действия по заявкам</h5>
      </div>
      <div class="card-body">
        <div class="flex justify-content-between flex_gap">
          <div class="flex-grow-1">
            <div class="flex flex_gap">
              <div class="form-group">
                <label for="">Период</label>
                <div>
                  <DateRangePicker
                    ref="range"
                  />
                </div>
              </div>
              <div class="form-group">
                <label for="">Время</label>
                <div class="input-group">
                  <TimeSelect ref="dateFrom"/>
                  <div class="input-group-prepend input-group-append">
                    <span class="input-group-text">по</span>
                  </div>
                  <TimeSelect ref="dateTo"/>
                  <div class="input-group-prepend input-group-append" v-if="allowToAdd">
                    <div>
                      <button @click="allowToAdd = !allowToAdd" class="btn btn-default"><i
                        class="icon-fa icon-fa-plus"/>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="input-group" v-if="!allowToAdd">
                  <TimeSelect ref="dateFrom2"/>
                  <div class="input-group-prepend input-group-append">
                    <span class="input-group-text">по</span>
                  </div>
                  <TimeSelect ref="dateTo2"/>
                  <div class="input-group-prepend input-group-append">
                    <div>
                      <button @click="allowToAdd = !allowToAdd" class="btn btn-default"><i
                        class="icon-fa icon-fa-remove"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group mb-0">
              <label for="">Менеджеры</label>
              <CustomMultiSelect ref="selectedUsers" :records="users"/>
            </div>
          </div>
          <div class="align-self-end">
            <LoadingButton
              title="Показать"
              :loading="loading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords()"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="loading || Object.keys(records).length">
      <div class="card-header">
        <h6>Активность менеджеров по заявкам</h6>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading && Object.keys(records).length">
          <div class="form-group">
            <label><input type="checkbox" v-model="showZero"> показывать 0 операций</label>
          </div>
          <table class="table table-sm table-hover table-bordered mt-0">
            <thead>
            <tr>
              <th rowspan="3">Дата</th>
              <th :colspan="selectedUsers.length * Object.keys(selectedTimeRanges).length">Менеджеры</th>
            </tr>
            <tr>
              <th :colspan="Object.keys(selectedTimeRanges).length" class="manager_name" v-for="u in selectedUsers">
                ({{ u.id }})
                {{ u.name }}
              </th>
            </tr>
            <tr>
              <template v-for="u in selectedUsers">
                <th v-for="(range, i) in selectedTimeRanges">{{ range.from }} - {{ range.to }}</th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,date) in records">
              <td>{{ date }}</td>
              <template v-for="u in selectedUsers">
                <td v-for="(range, i) in selectedTimeRanges">
                  <div class="flex flex_gap_10">
                    <template v-if="Object.keys(r[u.id]?.[i]?.orders ?? {}).length">
                      <v-popover
                        placement="bottom"
                        :auto-hide="true"
                      >
                    <span class="badge badge-info pointer">
                      <i class="icon-fa icon-fa-pencil-square-o"/>
                    </span>
                        <template slot="popover">
                          <div>
                            <p v-for="o in Object.keys(r[u.id]?.[i]?.orders ?? {})">{{ o }}</p>
                          </div>
                        </template>
                      </v-popover>
                      <v-popover
                        placement="bottom"
                        :auto-hide="true"
                      >
                    <span class="badge badge-info pointer">
                      <i class="icon-fa icon-fa-hand-pointer-o"/>
                    </span>
                        <template slot="popover">
                          <div>
                            <p v-for="a in Object.keys(r[u.id]?.[i]?.actions ?? {})">{{ traceActions[a] ?? a }}</p>
                          </div>
                        </template>
                      </v-popover>
                    </template>
                    {{
                      Object.keys(r[u.id]?.[i]?.orders ?? {}).length ? Object.keys(r[u.id]?.[i]?.orders ?? {}).length : (showZero ? 0 : '')
                    }}
                  </div>
                </td>
              </template>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import DateRange from "@/components/orders/dateRange.vue";
import TimeSelect from "@/components/dateSelect/TimeSelect.vue";
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";
import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import ActivityDownList from "@/views/admin/analitics/components/ActivityDownList.vue";
import IpNumbers from "@/views/telephony/ipNumbers.vue";
import ShiftActivation from "@/views/admin/analitics/components/ShiftActivation.vue";

export default {
  components: {
    ShiftActivation,
    IpNumbers, ActivityDownList, LoadingButton, CustomMultiSelect, TimeSelect, DateRange, DateRangePicker
  },
  title: 'Активность менеджеров',
  data() {
    return {
      loading: false,
      users: [],
      records: {},
      selectedUsers: [],
      selectedTimeRanges: {},
      allowToAdd: true,
      showZero: true,
      traceActions: {
        0: 'создание',
        11: 'удаление препарата',
        12: 'добавление препарата',
        13: 'количество препарата',
        17: 'добавлен телефон',
        18: 'добавление скидки',
        20: 'комментарий',
        21: 'адрес',
        23: 'дата доставки',
        27: 'саб статус',
        34: 'доп. согласование',
        38: 'звонок',
        40: 'изменение цены',
        45: 'детали адреса',
        48: 'передача на доставку',
        60: 'смена дивизиона',
      }
    }
  },
  created() {
    this.getUsers();
  },
  methods: {
    async getRecords() {
      const range = this.$refs.range.dateRange;
      const timeRange = {
        1: {
          from: this.$refs.dateFrom.displayDate,
          to: this.$refs.dateTo.displayDate,
        },
        2: {
          from: this.$refs.dateFrom2?.displayDate,
          to: this.$refs.dateTo2?.displayDate,
        }
      };
      if (!timeRange[1].from || !timeRange[1].to) {
        toastr["warning"]("Выберите время", "Ошибка");
        return;
      }
      if (!timeRange[2]?.from) {
        delete timeRange[2];
      }

      Object.keys(timeRange).forEach((i) => {
        Object.keys(timeRange[i]).forEach((r) => {
          if (timeRange[i][r]) {
            const temp = timeRange[i][r].split(':');
            if (+temp[0] > 0) {
              // timeRange[i][r] = (+temp[0] - 1) + ':' + temp[1];
            }
          }
        });
      });

      this.selectedTimeRanges = timeRange;
      this.selectedUsers = [...this.$refs.selectedUsers.selectedRecords];
      const selectedManagers = this.selectedUsers.map((s) => s.id);
      if (!selectedManagers.length) {
        toastr["warning"]("Выберите менеджеров", "Ошибка");
        return;
      }
      this.loading = true;
      const {data} = await api.post('/analytics/managers/activities', {
        dateRange: range,
        timeRange,
        ids: selectedManagers
      })
      if (data.success) {
        this.records = data.records;
      }
      this.loading = false;
    },
    async getUsers() {
      const {data} = await api.post('/new/users/list', {
        roles: ['manager', 'managerAssist']
      });
      if (data.success) {
        this.users = data.records.map((u) => {
          return {...u, selectTitle: '(' + u.id + ') ' + u.name}
        });
        // await this.$nextTick();
      }
    }
  }
}

</script>

<style scoped>
.flex_gap {
  gap: 10px;
}

.btn.btn-default {
  height: 38px;
}

.manager_name {
  width: 120px;
  text-wrap: wrap;
}

span i {
  color: white;
}
</style>
